export default "__VITE_PUBLIC_ASSET__bf44847f__"